import { IGeolocation } from '../../model/models/device/geolocation.interface';

export const GEOLOCATION_FIX_REUSE_MS = 10 * 60 * 1000;

export function isValidCoordinatePair(coords: IGeolocation | null): boolean {
  return !!coords
    && typeof coords.latitude === 'number' && typeof coords.longitude === 'number'
    && !isNaN(coords.latitude) && !isNaN(coords.longitude)
    && coords.latitude >= -90 && coords.latitude <= 90
    && coords.longitude >= -180 && coords.longitude <= 180;
}

export class ForeignIpGeolocationSession {
  static lastFix: IGeolocation = null;
  static pendingFix: Promise<IGeolocation | null> = null;
  static rejectionTracked = false;
  static promptInProgress: Promise<any> = null;
  static skippedOptionalPrompt = false;

  static getRecentFix(maxAgeMs = GEOLOCATION_FIX_REUSE_MS): IGeolocation | null {
    const fix = ForeignIpGeolocationSession.lastFix;
    if (fix && fix.timestamp && (Date.now() - fix.timestamp) < maxAgeMs) {
      return fix;
    }
    return null;
  }

  static rememberFix(fix: IGeolocation | null) {
    if (!isValidCoordinatePair(fix) || fix.isMock) {
      return;
    }
    fix.timestamp = fix.timestamp || Date.now();
    ForeignIpGeolocationSession.lastFix = fix;
  }

  static async trackPendingFix(read: Promise<IGeolocation | null>): Promise<IGeolocation | null> {
    const tracked = read.then((fix) => {
      ForeignIpGeolocationSession.rememberFix(fix);
      return fix;
    }, () => null);
    ForeignIpGeolocationSession.pendingFix = tracked;
    const clear = () => {
      if (ForeignIpGeolocationSession.pendingFix === tracked) {
        ForeignIpGeolocationSession.pendingFix = null;
      }
    };
    tracked.then(clear, clear);
    return tracked;
  }

  static resetForNewFlow() {
    ForeignIpGeolocationSession.rejectionTracked = false;
    ForeignIpGeolocationSession.promptInProgress = null;
  }

  static resetOptionalPromptSkip() {
    ForeignIpGeolocationSession.skippedOptionalPrompt = false;
  }

  static resetOnLogout() {
    ForeignIpGeolocationSession.resetForNewFlow();
    ForeignIpGeolocationSession.resetOptionalPromptSkip();
    ForeignIpGeolocationSession.lastFix = null;
    ForeignIpGeolocationSession.pendingFix = null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/foreign-ip-geolocation/foreign-ip-geolocation-session.ts